var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/svg/2000",
    viewBox: "0 0 32 32",
    width: 24,
    height: 24,
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 16C1.66699 8.08367 8.08404 1.66663 16.0003 1.66663C23.9166 1.66663 30.3337 8.08367 30.3337 16C30.3337 23.9162 23.9166 30.3333 16.0003 30.3333C8.08404 30.3333 1.66699 23.9162 1.66699 16ZM16.0003 3.66663C9.18861 3.66663 3.66699 9.18824 3.66699 16C3.66699 22.8117 9.18861 28.3333 16.0003 28.3333C22.812 28.3333 28.3337 22.8117 28.3337 16C28.3337 9.18824 22.812 3.66663 16.0003 3.66663ZM16.6863 9.25869C17.095 9.6302 17.1251 10.2626 16.7536 10.6713L16.7403 10.686C16.3688 11.0946 15.7363 11.1247 15.3277 10.7532C14.919 10.3817 14.8889 9.74927 15.2604 9.34062L15.2737 9.32595C15.6452 8.91729 16.2777 8.88718 16.6863 9.25869ZM16.0003 14.3333C16.5526 14.3333 17.0003 14.781 17.0003 15.3333V22C17.0003 22.5522 16.5526 23 16.0003 23C15.448 23 15.0003 22.5522 15.0003 22V15.3333C15.0003 14.781 15.448 14.3333 16.0003 14.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.d91b674d88e087e9a13519225f7e3bbc.svg";
export { ForwardRef as ReactComponent };